import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import { COURSE_SHARE_PATH, PAGE_LINKS } from '@/helpers/commonConsts'
import adminRoutes from '@/pages/admin/route'
import mobileRoutes from '@/pages/mobile/route'
import pcRoutes from '@/pages/pc/route'
import CourseShareRedirect from './CourseShareRedirect'

const routes: RouteObject[] = [
  {
    path: `${COURSE_SHARE_PATH}/:goodsId/:goodsType/:resourceId/:check`,
    element: <CourseShareRedirect />,
  },
  ...mobileRoutes,
  ...adminRoutes,
  ...pcRoutes,
  {
    path: '*',
    element: <Navigate to={PAGE_LINKS.home} replace />,
  },
]

export const Router = () => {
  return useRoutes(routes)
}
